import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../common/api-service.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class BannerService {
	constructor(private readonly apiservice: ApiService) {}

	/**
   * @description banner api parameters.
   */
	public bannerParams = new HttpParams({
		fromObject: {
			grant_type: 'client_credentials',
			client_secret: 'L6eWGm[6g]H:h1*aLex68djeU_@950aU',
			client_id: 'b757d200-c77f-42a5-9376-cf7b0586ae0c'
		}
	});

	/**
   * @description generate the banner api url.
   */
	public getBannerAPIUrl() {
		return `${environment.baseUrl}/learn/1.0/committee`;
	}

	/**
   * @description generate the banner api url.
   */
	public getAuthTokanAPIUrl() {
		return 'https://login.microsoftonline.com/e972228d-0f41-4884-b3dc-5bac04d84216/oauth2/token';
	}

	/**
   * @description get the student data from the banner api.
   * @param data data request.
   * @param successCallback success callback.
   * @param failureCallback failure callback.
   */
	public getAuthTokenForBanner(data, successCallback, failureCallback) {
		this.apiservice.doPost(
			this.getAuthTokanAPIUrl(),
			data,
			(response) => {
				successCallback(response);
			},
			(error) => {
				failureCallback(error);
			}
		);
	}

	/**
   * @description get the student data from the banner api.
   * @param email email of the student logged in.
   * @param successCallback success callback.
   * @param failureCallback failure callback.
   */
	public getBannerDetailsfromAPI(email, successCallback, failureCallback) {
		this.apiservice.doGet(
			this.getBannerAPIUrl(),
			email,
			(response) => {
				successCallback(response);
			},
			(error) => {
				failureCallback(error);
			}
		);
	}
}
